import {searchModel} from "../../../../Utilities/Search";
import {isNullOrUndefined} from "../../../../Utilities/commonUtilities";
import {isArrayNullOrEmpty} from "../../../../Utilities/Types/arrayUtilities";
import {dynamicSort} from "../../../../Utilities/Sort";

export const ownCatalogSearchModel = (userId = "", searchTerm = "", catalogNumber = "") => {
    return Object.assign({}, searchModel(userId.toString(), "title", false, "title"), {
        searchTerm: searchTerm,
        catalogNumber: catalogNumber,
        objectType: null,
        ClearCatalogSearch: clearCatalogSearch,
        ApplySorting: applySorting,
    });
};

function clearCatalogSearch(this: Record<string, unknown>) {
    this.searchTerm = "";
    this.catalogNumber = "";
    this.objectType = null;
    (this as { ClearSearch: (load: boolean) => void }).ClearSearch(false);
}

function applySorting(ownSearchCriteria: Record<string, unknown>, items: Record<string, unknown>[]) {
    if (isNullOrUndefined(items) || isArrayNullOrEmpty(items))
        return items;

    return items.sort(dynamicSort(ownSearchCriteria.sortByColumn as string, ownSearchCriteria.sortDescending as boolean));
}
